import React from "react";
import * as Mui from "@material-ui/core";
import { useStyles } from "./TablePagination.styles";

export function TablePagination(props) {
  const classes = useStyles();
  return <Mui.TablePagination classes={classes} component="div" {...props} />;
}
